// App configuration settings
export const APP_SETTINGS = {
  // General settings
  APP_NAME: 'RecipeCast',
  THEME_COLOR: '#4CAF50',
  
  // UI settings
  DEFAULT_FONT_SIZE: 24, // Base font size for TV displays
  TOUCH_FONT_SIZE: 18,   // Base font size for touch devices
  MARGINS: 32,           // Standard margin for UI elements
  ANIMATION_DURATION: 300, // Duration for transitions in ms
  
  // Layout settings
  MAX_WIDTH: 1920, // Maximum width of the UI (for TV screens)
  CONTENT_WIDTH: 1280, // Optimal content width
  SIDEBAR_WIDTH: 400, // Width of sidebar/navigation area
  
  // Recipe display settings
  STEPS_FONT_SIZE: 28, // Font size for recipe steps
  INGREDIENTS_FONT_SIZE: 20, // Font size for ingredients list
  DEFAULT_SERVINGS: 4, // Default number of servings
  
  // Touch interface settings
  TOUCH_TARGET_SIZE: 56, // Minimum touch target size (in pixels)
  TOUCH_PADDING: 16, // Padding around touch targets
  
  // Cast settings
  IDLE_TIMEOUT: 14400000, // 4 hours in milliseconds
}
